import SvgImage from '@/components/Module/SvgImage';
import useFarmCongestion from '@/components/MenuDrawer/MyMenuDrawer/SubMenu/Olive/Congestion/@hook/useFarmCongestion';
import CongestionCard from '@/components/MenuDrawer/MyMenuDrawer/SubMenu/Olive/Congestion/CongestionCard';
import { useTranslation } from 'react-i18next';

const Congestion = () => {
  const { t } = useTranslation();
  const { congestionStatus, statusLevel, currentTimeTable, currentStatus } =
    useFarmCongestion(true);

  return (
    <div>
      <div
        style={{
          display: 'flex',
          padding: '12px 20px',
          borderTop: '1px solid var(--dk-line, #E7E9EC)',
          borderBottom: '1px solid var(--dk-line, #E7E9EC)',
        }}
      >
        {[4, 1, 2, 3].map((level) => (
          <CongestionCard
            key={congestionStatus[level].title}
            {...congestionStatus[level]}
            isSelected={statusLevel === level}
          />
        ))}
      </div>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '28px 0 24px 0',
        }}
      >
        {
          <div style={{ position: 'relative' }}>
            <SvgImage name={currentStatus.svgImageName} />
            <div
              style={{
                position: 'absolute',
                top: '70%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                textAlign: 'center',
                whiteSpace: 'nowrap',
              }}
            >
              <div
                style={{
                  color: 'var(--dk-text-strong, #5F636B)',
                  fontSize: '14px',
                  fontWeight: '400',
                  lineHeight: '20px',
                }}
              >
                {currentTimeTable
                  ? currentTimeTable
                  : t('MYPAGE.지금 구내식당은')}
              </div>
              <div
                style={{
                  fontSize: '20px',
                  fontWeight: 700,
                  lineHeight: '28px',
                  color: currentStatus.contentColor,
                }}
              >
                {currentStatus.subTitle}
              </div>
            </div>
          </div>
        }
      </div>
    </div>
  );
};
export default Congestion;
